<template>
  <div class="file-uploader">
    <div v-if="checkType === 'media_video'" class="file-uploader__input" @click="onFileuploaderClicked">
      <input v-model="uploadType" type="radio" value="vimeo">

      <input v-model="vimeoLink" type="text" class="form-control" placeholder="Place link to vimeo">
    </div>

    <div v-if="checkType === 'media_video'" class="file-uploader__input" @click="onFileuploaderClicked">
      <input v-model="uploadType" type="radio" value="youtube">

      <input v-model="youtubeLink" type="text" class="form-control" placeholder="Place link to youtube">
    </div>

    <div v-if="checkType !== 'media_video'" class="file-uploader__input" @click="onFileuploaderClicked">
      <input v-model="uploadType" type="radio" value="url">
      <SelectelUploader
        v-if="pathPrefix"
        :file-link="fileLink"
        :selectel-list="selectelList"
        :selectel-loading="selectelLoading"
        :link-status="linkStatus"
        @blur="checkLink"
        @file-attached="attachFile"
      />
    </div>

    <div class="file-uploader__dropzone">
      <input v-model="uploadType" type="radio" value="file">
      <Dropzone
        v-if="checkType !== 'media_video' || defaultFile"
        id="files-uploader"
        ref="dropzone"
        class="dropzone-noprogress"
        :options="dropzoneOptions"
        @vdropzone-removed-file="fileChanged"
        @vdropzone-file-added="fileChanged"
      />
      <div v-else class="file-uploader__multiple-dropzone">
        <VideoQualityUploader
          :check-type="checkType"
          :quality-array="qualityArray"
          :dropzone-options="dropzoneOptions"
          :selectel-list="selectelList"
          :selectel-loading="selectelLoading"
          :default-files="defaultFiles"
          :uploaded-files="uploadedFilesDictionary"
          @content-change="onContentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';

import { uploadStatus } from '@/helpers/constants';
import SelectelUploader from './SelectelUploader';
import VideoQualityUploader from './VideoQualityUploader';

const { SUCCESS } = uploadStatus;

export default {
  components: {
    Dropzone,
    SelectelUploader,
    VideoQualityUploader,
  },

  props: {
    dropzoneOptions: {
      type: Object,
      default: () => ({
        url: '/',
      }),
    },
    defaultFile: {
      type: Object,
      default: null,
    },
    defaultFiles: {
      type: Object,
      default: null,
    },
    pathPrefix: {
      type: String,
      default: '',
    },
    checkType: {
      type: String,
      default: 'media_video',
    },
    vimeo: {
      type: String,
      default: '',
    },
    youtube: {
      type: String,
      default: '',
    },
    uploadingFile: {
      type: Object,
      default: null,
    },
    uploadedFilesDictionary: {
      type: Object,
      default: null,
    },
    startType: {
      type: String,
      default: 'file',
    },
  },

  data: () => ({
    uploadType: 'file',
    fileLink: '',
    file: null,
    linkStatus: null,
    lastCheckedLink: '',
    showSelectelList: false,
    selectelList: null,
    selectelLoading: false,
    youtubeLink: '',
    vimeoLink: '',
    qualityArray: [
      144,
      240,
      360,
      480,
      720,
      1080,
    ],
  }),

  watch: {
    uploadType() { this.emitInput(); },
    fileLink() { this.emitInput(); },
    youtubeLink() { this.emitInput(); },
    vimeoLink() { this.emitInput(); },
    uploadingFile(val) {
      if (!this.$refs) return;
      if (!val) return;
      if (val.status === SUCCESS) {
        const { dropzone } = this.$refs;
        dropzone.removeAllFiles();
        dropzone.manuallyAddFile(val.file,
          `${this.$config.app_api.host}${this.$config.app_api.prefix}
          /media/video/${this.$route.params.id}/file`);
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        this.file = val.file;
      }
    },
    uploadedFilesDictionary(val) {
      if (val) {
        Object.keys(val).forEach((quality) => {
          const dropzone = this.$refs[`dropzone${quality}`];
          if (dropzone) {
            dropzone[0].removeAllFiles();
            dropzone[0].manuallyAddFile(val[quality]);
          }
        });
      }
    },
  },

  created() {
    this.uploadType = this.startType;
    this.youtubeLink = this.youtube;
    this.vimeoLink = this.vimeo;
  },

  mounted() {
    $(document).on('click', this.blurPopup);
    if (this.currentFile) {
      this.$refs.dropzone.manuallyAddFile(this.currentFile,
        `${this.$config.app_api.host}${this.$config.app_api.prefix}
        /media/video/${this.$route.params.id}/file`);
    }
    if (this.defaultFile) {
      this.manuallyAddFile();
    }
    this.getSelectelFiles();
    this.emitInput();
  },

  beforeDestroy() {
    $(document).off('click', this.blurPopup);
  },

  methods: {
    getSelectelFiles() {
      this.selectelLoading = true;
      this.$apiHttp.get(`${this.$config.app_api.prefix}selectel?prefix=${this.pathPrefix}`)
        .then((response) => {
          this.selectelList = response.data;
        })
        .catch((error) => { console.error(error); })
        .finally(() => { this.selectelLoading = false; });
    },
    blurPopup(e) {
      if (!$(e.target).hasClass('file-uploader__folder')
          && !$(e.target).parents('.file-uploader__folder').length
      ) {
        this.showSelectelList = false;
      }
    },

    manuallyAddFile() {
      const file = {
        file: {
          name: this.defaultFile.file_name,
          size: this.defaultFile.size,
        },
        url: this.defaultFile.public_url,
        thumb: this.defaultFile.thumbnail || 'static/img/file-thumb.jpg',
      };
      this.$refs.dropzone.manuallyAddFile(file.file, file.url);
      if (!this.defaultFile.mime_type.match(/image.*/)) {
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
      }
    },

    checkLink() {
      if (!this.fileLink) return;
      if (this.lastCheckedLink === this.fileLink) return;
      this.linkStatus = 'loading';
      this.lastCheckedLink = this.fileLink;
      const postFormData = new FormData();
      postFormData.append('selectel_file_url', this.fileLink);
      postFormData.append('content_type', this.checkType);
      this.$apiHttp.post(`${this.$config.app_api.prefix}selectel/check-link`, postFormData)
        .then(() => {
          this.linkStatus = 'ok';
        })
        .catch(() => {
          this.linkStatus = 'error';
        });
    },
    fileChanged() {
      [this.file] = this.$refs.dropzone.dropzone.files;
      this.$el.querySelectorAll('.file-uploader__input').forEach((item) => {
        item.childNodes[0].checked = false;
      });
      this.$el.querySelector('.file-uploader__dropzone').childNodes[0].checked = true;
      this.uploadType = 'file';
      this.emitInput();
    },
    onContentChange(filesDictionary) {
      this.$el.querySelectorAll('.file-uploader__input').forEach((item) => {
        item.childNodes[0].checked = false;
      });
      this.$el.querySelector('.file-uploader__dropzone').childNodes[0].checked = true;
      this.uploadType = 'file';
      this.filesDictionary = filesDictionary;
      this.emitInput();
    },
    emitInput() {
      this.$emit('input', {
        uploadType: this.uploadType,
        fileLink: this.fileLink,
        file: this.file,
        filesDictionary: this.filesDictionary,
        youtube: this.youtubeLink,
        vimeo: this.vimeoLink,
      });
    },
    attachFile(url) {
      this.showSelectelList = false;
      this.fileLink = url;
    },
    onFileuploaderClicked(event) {
      this.$el.querySelectorAll('.file-uploader__input').forEach((item) => {
        item.childNodes[0].checked = false;
      });
      this.$el.querySelector('.file-uploader__dropzone').childNodes[0].checked = false;
      const target = event.currentTarget;
      target.childNodes[0].checked = true;
      this.uploadType = target.childNodes[0].value;
    },
  },
};
</script>

<style>
  .file-uploader {
    padding: 10px;
    border: 1px solid rgba(0,0,0,0.15);
    background: #f5f5f6;
  }
  .file-uploader__input {
    position: relative;
    display: flex;
    margin-bottom: 10px;
  }
  /* .control-group {
    width: 100%;
  }
  .control-group .col-md-9 {
    padding-right: 7px;
    padding-left: 0;
  } */
  input[type="radio"] {
    margin-top: 10px;
    margin-right: 10px;
  }
  .file-uploader__dropzone {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .file-uploader__dropzone > .dropzone {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// Index.vue?1332ac3e